import { render, staticRenderFns } from "./SelectMultipleQueue.vue?vue&type=template&id=35eccf05&"
import script from "./SelectMultipleQueue.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleQueue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports